// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseGenericCaseModelResponse {
    static getAttributeTypeMap() {
        return CaseGenericCaseModelResponse.attributeTypeMap;
    }
}
CaseGenericCaseModelResponse.discriminator = undefined;
CaseGenericCaseModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "CaseGenericCaseModel"
    }
];
//# sourceMappingURL=caseGenericCaseModelResponse.js.map